<dialog
  id="add-problem-modal"
  class="modal"
  [class.modal-open]="showProblemModal()">
  <div class="modal-box w-9/12 max-w-4xl max-h-[90vh] flex flex-col overflow-hidden">
    <!-- Fixed Header -->
    <div class="flex flex-col p-6 pb-0 flex-none">
      <h1 class="font-semibold text-3xl mb-5">Select Problem</h1>
      <div class="flex flex-row justify-between mb-4 items-center">
        <div class="relative w-72">
          <input
            type="text"
            name="search"
            placeholder="Type here"
            class="input input-bordered w-full pr-10 rounded-lg placeholder-gray-300 text-base"
            (input)="searchQuery.set($any($event.target).value)" />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-5 w-5 absolute right-3 top-1/2 -translate-y-1/2 text-gray-300"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
        </div>
        <div class="dropdown dropdown-end">
          <div tabindex="0" role="button" class="text-gray-400 flex flex-row m-1 hover:cursor-pointer items-center gap-1.5">
            Filter
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M6.66667 12V10.6667H9.33333V12H6.66667ZM4 8.66667V7.33333H12V8.66667H4ZM2 5.33333V4H14V5.33333H2Z"
                fill="#9F9FA9" />
            </svg>
          </div>
          <ul
            tabindex="0"
            class="dropdown-content z-[1] menu p-4 shadow bg-base-100 rounded-box w-52">
            <div class="flex flex-col items-center gap-4 justify-start">
              <label class="label cursor-pointer w-full">
                <input
                  type="radio"
                  name="filter"
                  class="checkbox checkbox-neutral"
                  [checked]="filterOption() === 'all'"
                  (change)="filterOption.set('all')" />
                <span class="ml-2">All items</span>
              </label>
              <label class="label cursor-pointer w-full">
                <input
                  type="radio"
                  name="filter"
                  class="checkbox checkbox-neutral"
                  [checked]="filterOption() === 'selected'"
                  (change)="filterOption.set('selected')" />
                <span class="ml-2">Only selected</span>
              </label>
              <label class="label cursor-pointer w-full">
                <input
                  type="radio"
                  name="filter"
                  class="checkbox checkbox-neutral"
                  [checked]="filterOption() === 'not_selected'"
                  (change)="filterOption.set('not_selected')" />
                <span class="ml-2">Not selected</span>
              </label>
            </div>
          </ul>
        </div>
      </div>
    </div>

    <!-- Scrollable Content -->
    <div class="flex-1 overflow-y-auto px-6 py-4 shadow-inner rounded-lg">
      <div class="flex flex-col space-y-4">
      @for(item of filteredProblems(); track item.problemId) {
        <app-item
          [id]="item.problemId"
          [title]="item.title"
          [description]="item.description"
          [difficulty]="item.difficulty"
          [duration]="item.duration"
          [selector]="'checkbox'"
          [name]="'problemCheckbox'"
          (selectItem)="toggleTempSelection(item.problemId)"
          id="problem-item-modal"/>
      } @empty {
      <p class="text-center text-gray-500">No problems available.</p>
      }
      </div>
    </div>

    <!-- Fixed Footer -->
    <div class="p-6 pt-4 flex-none">
      <div class="flex justify-end gap-5">
        <app-button
          type="button"
          label="Cancel"
          (clicked)="closed.emit()" />
        <app-button
          color="primary"
          type="button"
          label="Add"
          (clicked)="confirmSelection()"
          id="add-problem-modal-button"/>
      </div>
    </div>
  </div>
</dialog>
